import React, { useState } from "react";
import { Box } from '@mui/joy';
import { Pie, Table, Timeline } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import KPISet from "./KPISet";
import useFiltersFromLocation from "src/mtska-frontend-app-scaffolding/hooks/useFiltersFromLocation";
import Filters from './Filters'
import { useNavigate } from 'react-router-dom'


const LeadDashboard = React.forwardRef((props, ref) => {

    const showKPI = true;
    const showPIE = true;
    const showTimelineLead = true;
    const showSummary = false;
    const showTimelineCommission = false;
    const showActionables = false;

    const { t } = useTranslation();
    const navigate = useNavigate()

    const [filters, setFilters] = useFiltersFromLocation();

    function handleFilterChange(field, newValue) {
        setFilters(prevFilters => {
            const items = Array.isArray(prevFilters?.items) ? [...prevFilters.items] : [];
            const index = items.findIndex(item => item.field === field);

            if (index !== -1) {
                items[index] = { ...items[index], value: newValue };
            } else {
                items.push({
                    field,
                    operator: "equals",
                    value: newValue
                });
            }

            return {
                ...prevFilters,
                items
            };
        });

        setTimeout(() => {
            if (props.setFilters) {
                props.setFilters(filters);
            }
        }, 500)
    }

    const createSliceFilterHandler = (field, handleFilterChange) => (params) => {
        handleFilterChange(field, params);
    };


    const createTimelineBarFilterHandler = (field, handleFilterChange) => (params) => {
        const [monthStr, yearStr] = params.split(' ');
        const month = parseInt(monthStr, 10) - 1;
        const year = parseInt(yearStr, 10);

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        //navigate('/cars/car?_related_contract_end_at=' + JSON.stringify({ from: start, to: end }));
    };

    const getTransposedDate = (months) => {
        const today = new Date();
        today.setMonth(today.getMonth() + months);

        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    }

    return (
        <Box ref={ref}>
            {showKPI &&
                <Box className="dashboard-section-title" sx={{ marginTop: '30px', marginBottom: '10px' }}>
                    <h2>{t('Lead status')}</h2>
                </Box>
            }
            {showKPI &&
                <Box className="dashboard-menu-itemgroup">
                    <KPISet filters={filters} />
                </Box>
            }
            <Filters filters={filters} setFilters={setFilters} />
 
            {showPIE &&
                <Box className="dashboard-menu-itemgroup" sx={{ marginTop: '30px', marginBottom: '30px' }}>
                    
                     <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Lead by Area")}
                            dataProviderName={"statisticsviews/leadsperarea/aggregated/views_opportunities_lead/_related_area_name"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('_related_area_name', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Lead by Shop")}
                            dataProviderName={"statisticsviews/leadspershop/aggregated/views_opportunities_lead/_related_shop_name"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('_related_shop_name', handleFilterChange)}
                        />
                    </Box><Box className="dashboard-menu-item">
                        <Pie
                            title={t("Lead by Agent")}
                            dataProviderName={"statisticsviews/leadsperagent/aggregated/views_opportunities_lead/_related_agent_fullname"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('_related_agent_fullname', handleFilterChange)}
                        />
                    </Box>
                     <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Lead by Source")}
                            dataProviderName={"statisticsviews/leadspersource/aggregated/views_opportunities_lead/_related_source_name"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('_related_source_name', handleFilterChange)}
                        />
                    </Box>
                </Box>
            }
            {showPIE &&
                <Box className="dashboard-menu-itemgroup" sx={{ marginTop: '30px', marginBottom: '30px' }}>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Leads by Status")}
                            dataProviderName={"statisticsviews/leadsbystatus/aggregated/views_opportunities_lead/status"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('status', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Lead by Product")}
                            dataProviderName={"statisticsviews/leadspersource/aggregated/views_opportunities_lead/product"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('product', handleFilterChange)}
                        />
                    </Box>
                </Box>
            }
            
            {showTimelineLead &&
                <Box className="dashboard-section-title">
                    <h2>{t('Lead per settimana')}</h2>
                </Box>
            }
            {showTimelineLead &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-timeline" sx={{ marginTop: '10px', marginBottom:'30px' }}>
                    <Box className="dashboard-menu-item">
                        <Timeline
                            title={t("Lead per settimana")}
                            dataProviderName="statisticsviews/leadbyweek/timelined/views_opportunities_lead/registered_at/week"
                            //format="currency"
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "registered_at",
                                        operator: "between",
                                        value: {
                                            from: getTransposedDate(-12),
                                            to: getTransposedDate(0),
                                        }
                                    }
                                ]
                            }}
                            handleFilterChange={createTimelineBarFilterHandler('registered_at', handleFilterChange)}
                        />
                    </Box>
                </Box>
            }
        </Box>
    )
})
export default LeadDashboard